export default __webpack_public_path__ + "static/media/sf_3.19d53367.PNG";